import { Fragment } from "react";
import paths from "routing/paths";
import { Banner } from "components";
import styles from "./ImageNavigation.module.scss";
import { isPackaged } from "index";

const ImageNavigation = ({ home = false }) => {
  const pathPrefix = () => {
    return isPackaged ? (!home ? ".." : ".") : "";
  };
  const navArray = [
    <a
      className="anim-nav-link"
      href={pathPrefix() + paths.GRADE_MANAGEMENT}
      aria-label="navigate to grade management"
    >
      <p>eliminate rework</p>
      <div className={styles["grade-management"]} />
    </a>,
    <a
      className="anim-nav-link"
      href={pathPrefix() + paths.OBSTACLE_INTELLIGENCE}
      aria-label="navigate to obstacle intelligence"
    >
      <p>improve jobsite safety</p>
      <div className={styles["obstacle-intelligence"]} />
    </a>,
    <a
      className="anim-nav-link"
      href={pathPrefix() + paths.JOBSITE_AUTOMATION}
      aria-label="navigate to jobsite automation"
    >
      <p>
        counteract
        <br /> labor shortages
      </p>
      <div className={styles["jobsite-automation"]} />
    </a>,
    <a
      className="anim-nav-link"
      href={pathPrefix() + paths.OPERATIONS_MANAGEMENT}
      aria-label="navigate to operations management"
    >
      <p>increase efficiency</p>
      <div className={styles["operations-management"]} />
    </a>,
  ];
  return (
    <section className={`${styles["image-navigation"]}`}>
      <Banner
        title="WHATEVER YOU'RE UP AGAINST, WE HAVE THE TOOLS TO HELP YOU GET THE JOB  DONE."
        subtitle="SEE BELOW FOR ALL THE WAYS WE CAN HELP."
        imgNav
      />
      <div className={`${styles["image-wrapper"]} anim-navigation`}>
        {navArray.map((item, i) => (
          <Fragment key={i}>{item}</Fragment>
        ))}
      </div>
    </section>
  );
};

export default ImageNavigation;
